import React, { useState, useEffect } from "react";
//import $ from 'jquery'
export const ProductOptionRefContext = React.createContext();

const ProductOptionRefProvider = ({ children }) => {
	const urlParams = new URLSearchParams(window.location.search);
	const sku = urlParams.get("sku");
    const [typeToScroll, setTypeToScroll] = useState(null);
	const [first, setFirst] = useState((sku ? false : true))
	
	const scrollToRef = type => {
		if (!first) {
			setTypeToScroll(type)
		}
		else {
			setFirst(false)
		}
		
	};

	const clearTypeToScroll = () => {
		setTypeToScroll(null)
	}

    const value = {
        scrollToStep: scrollToRef,
		typeToScroll,
		clearTypeToScroll
	};
	
    return (
        <ProductOptionRefContext.Provider value={value}>
            {children}
        </ProductOptionRefContext.Provider>
    );
};

export default ProductOptionRefProvider;
